import { AdaptiveCardEventTypes, } from '@office-start/adaptive-card-types';
import { dialogPromiseHandlers } from '@office-start/app-host-service';
import { launchUrl } from '@office-start/launcher-service';
import { submitTaskModule } from '@office-start/task-module-dialog-service';
var appHostAdaptiveCardEventHandler = function (event, actions) {
    var _a, _b;
    var novaEvent = event && event;
    if (novaEvent.type === AdaptiveCardEventTypes.openUrlEvent &&
        novaEvent.data) {
        var eventData = novaEvent.data();
        if (eventData.url) {
            (_a = actions.openUrlEvent) === null || _a === void 0 ? void 0 : _a.call(actions, eventData.url);
        }
    }
    else if (novaEvent.type === AdaptiveCardEventTypes.submitActionEvent &&
        novaEvent.data) {
        var eventData = novaEvent.data();
        if (eventData.data) {
            (_b = actions.submitEvent) === null || _b === void 0 ? void 0 : _b.call(actions, eventData.data);
            submitTaskModule();
        }
    }
};
export var getAppHostAdaptiveCardEventHandler = function (_a) {
    var event = _a.event;
    var submitEvent = function (data) {
        dialogPromiseHandlers.externalResolver(data);
    };
    var openUrlEvent = function (url) {
        launchUrl(url, { action: 'OpenInBrowser' });
    };
    return appHostAdaptiveCardEventHandler(event, {
        submitEvent: submitEvent,
        openUrlEvent: openUrlEvent,
    });
};
//# sourceMappingURL=getAppHostAdaptiveCardEventHandler.js.map